module.exports = __webpack_public_path__ + "assets/img/szjz_3.814bb1ab.png";